module.exports = __webpack_public_path__ + "img/feather.df8432b4.svg";